module.exports = __webpack_public_path__ + "img/e_3_15_r.23a82865.png";